/*
 * @Author: DLLCNX dllcnx@foxmail.com
 * @Date: 2023-12-26 09:56:15
 * @LastEditors: DLLCNX dllcnx@foxmail.com
 * @LastEditTime: 2024-02-21 11:46:46
 * @FilePath: /smartEarthDemo/src/components/util.js
 * @Description: 
 */
import * as Cesium from "cesium/Cesium";

export default {
    getViewer(container, optUser) {
        // Cesium.Ion.defaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJmZDc4MDllZS01NDZmLTQwNTEtOWYxNy1mZGJhMDVkNjUzOWIiLCJpZCI6MTM0NzksInNjb3BlcyI6WyJhc3IiLCJnYyJdLCJpYXQiOjE1NjMzNTY3MDV9.OGQjCz3Xjb3uNrF89AUmasVwNTFVXFdP6RoqU-q853U';
        Cesium.Ion.defaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIzNWZhODgzMC1iNmE5LTQzNWMtOTdiYi00NzAyMzhmZDdmNjgiLCJpZCI6MTg3NTAyLCJpYXQiOjE3MDQyNDkwODl9.81WSf-TbP_6rNXQpVmuQaca_IrKpBje4NKk-BQxt4hg';
        console.log(123)
        let optDefault = {
            timeline: false,
            animation: false,
            sceneModePicker: false,
            fullscreenElement: container,
            navigationHelpButton: false,
            baseLayerPicker: false,
            geocoder: false,
            selectionIndicator: false,
            infoBox: false,
            homeButton: false,
        };
        let opt = null;
        if (optUser) {
            opt = Object.assign(optDefault, optUser);
        } else {
            opt = optDefault;
        }
        let viewer = new Cesium.Viewer(container, opt);
        viewer.cesiumWidget.creditContainer.style.display = "none";
        // viewer.sceneModePicker.viewModel.duration = 0.0;
        window.vw = viewer;
        return viewer;
    },
    setViewRegion(viewer) {
        let heading = 6.151011316994014;
        let pitch = -0.3866398424631803;
        let roll = 0.009400659179889637;
        viewer.camera.setView({
            destination: {
                x: -2100559.2312219488,
                y: 4728355.2008848945,
                z: 3882832.8279415495
            },
            orientation: {
                heading,
                pitch,
                roll
            }
        })
    },
    setViewHill(viewer) {
        let heading = 5.393693269104002;
        let pitch = -0.3798025510201679;
        let roll = 6.280767850782176;
        viewer.camera.setView({
            destination: {
                x: -416589.0472091964,
                y: 5533356.915926512,
                z: 3148545.3277710644
            },
            orientation: {
                heading,
                pitch,
                roll
            }
        })
    },
}
